import moment from 'moment'
import { EhrAppointmentStateKind } from '@src/types.ts'
import Storage, { useStorageValue } from '@utils/storage.ts'
import { LatestEhrAppointmentCustomType } from '../utils'

export const useAppointmentSoonAlert = (appointment: LatestEhrAppointmentCustomType | null) => {
  const callSoonAlertClosedKey = `${Storage.CALL_SOON_ALERT_CLOSED_KEY}_${appointment?.id}`
  const [callSoonAlertClosed, setCallSoonAlertClosed] = useStorageValue(callSoonAlertClosedKey)

  const onClose = () => {
    if (appointment) {
      setCallSoonAlertClosed(true)
    }
  }

  const showCallSoonAlert =
    !callSoonAlertClosed &&
    appointment?.meetingAt &&
    new Date(appointment.meetingAt) > new Date() &&
    appointment.lastState.kind === EhrAppointmentStateKind.Scheduled &&
    moment(appointment.meetingAt).diff(moment(), 'hours') < 24

  return { showCallSoonAlert, onClose }
}
